import { useEffect } from 'react';
import { expandUrlTempleRemoveQueryParams } from 'src/apis/hydrogen-fcfs/mappings';
import type {
  HydrogenNetworkPointPricesRequestParams,
  HydrogenNetworkPointPrices,
  OptionalUrlTemplate,
  UrlTemplate,
} from 'src/apis/hydrogen-fcfs/types';
import { useAxios } from 'src/hooks/use-axios';

type HookParams = {
  params: HydrogenNetworkPointPricesRequestParams;
} & OptionalUrlTemplate;

type RequestParams = {
  params: HydrogenNetworkPointPricesRequestParams;
} & UrlTemplate;

export function useHydrogenNetworkPointPrices({ url, params }: HookParams) {
  const request = useAxios(
    (axios, baseConfig, { url, params }: RequestParams) =>
      axios.request<HydrogenNetworkPointPrices>({
        ...baseConfig,
        url: expandUrlTempleRemoveQueryParams(url),
        params,
      }),
    {
      neededOnPageLoad: true,
    }
  );

  useEffect(() => {
    if (!url) return;
    request.execute({ url, params });
    // oxlint-disable-next-line exhaustive-deps
  }, [url, params]);

  if (!url) return;

  return request;
}

export type HydrogenNetworkPointPricesRequest = ReturnType<
  typeof useHydrogenNetworkPointPrices
>;
